<template>
  <el-select
    :placeholder="placeholder"
    :value="value"
    multiple
    :collapse-tags="value.length >= 4"
    :filterable="filterable"
    :default-first-option="filterable"
    :allow-create="allowCreate"
    @change="onChange"
  >
    <el-option-group v-if="value.length > 0">
      <el-option label="Clear" :value="CONSTANTS.CLEAR" />
    </el-option-group>
    <el-option-group v-if="allButton">
      <el-option label="All" :value="CONSTANTS.ALL" />
    </el-option-group>
    <el-option-group v-if="selectPresetChoices.length">
      <el-option :label="selectPresetChoicesLabel" :value="CONSTANTS.PRESET" />
    </el-option-group>
    <el-option-group>
      <el-option
        v-for="item in choices"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-option-group>
  </el-select>
</template>

<script>
export default {
  name: 'MultiSelect',
  props: {
    placeholder: {
      type: String,
      default: () => 'Choose items',
    },
    allButton: {
      type: Boolean,
      default: false,
    },
    choices: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    selectPresetChoices: {
      type: Array,
      default: () => [],
    },
    selectPresetChoicesLabel: {
      type: String,
      default: 'Preset choices',
    },
  },
  computed: {
    CONSTANTS() {
      return { ALL: '__ALL__', CLEAR: '__CLEAR__', PRESET: '__PRESET__' }
    },
  },
  methods: {
    onChange(selectedItems) {
      if (selectedItems.indexOf(this.CONSTANTS.ALL) >= 0) {
        selectedItems = this.choices.map((c) => c.value)
      } else if (selectedItems.indexOf(this.CONSTANTS.CLEAR) >= 0) {
        selectedItems = []
      } else if (selectedItems.indexOf(this.CONSTANTS.PRESET) >= 0) {
        selectedItems = this.selectPresetChoices
      }
      this.$emit('input', selectedItems)
      this.$emit('change', selectedItems)
    },
  },
}
</script>
